/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiescolumnsupply2Inputs */

const en_opportunitiescolumnsupply2 = /** @type {(inputs: Opportunitiescolumnsupply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supply`)
};

const de_opportunitiescolumnsupply2 = /** @type {(inputs: Opportunitiescolumnsupply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebot`)
};

/**
* | output |
* | --- |
* | "Supply" |
*
* @param {Opportunitiescolumnsupply2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiescolumnsupply2 = /** @type {((inputs?: Opportunitiescolumnsupply2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiescolumnsupply2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiescolumnsupply2(inputs)
	return de_opportunitiescolumnsupply2(inputs)
});
export { opportunitiescolumnsupply2 as "opportunitiesColumnSupply" }